import React, { useState, useContext, useEffect } from "react";
import Deliveredsearch from "../delivered/Deliveredsearch";
import Deliveredtitle from "../delivered/Deliveredtitle";
import Delivereditems from "../delivered/Delivereditems";
import { useAuth } from "../../hooks/customers/AuthProvider";
import * as Config from "../../config/config";
import { LoaderContext } from "../utils/Contexts";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import { useTranslation } from 'react-i18next';

function Delivered() {
  const auth = useAuth();
  const { t } = useTranslation();
  const customerId = auth.customer._id;
  // State for search input
  const [searchTerm, setSearchTerm] = useState("");
  const { isLoader, setLoader } = useContext(LoaderContext);
  const [orders, setOrders] = useState([]);

  const handleInputChange = (e) => {
    const keayword = e.target.value;
    setSearchTerm(keayword);
  };

  const getOrders = async () => {
    setLoader(true);
    let url = `${ENDPOINTS.SUBMIT_ORDER}/${customerId}?status=4&limit=${Config.ORDERS_LIMIT}`;
    if (searchTerm) {
      url = `${url}&invoice_no=${searchTerm}`;
    }
    const response = await API.getWithToken(url);
    if (response.statusText === "OK") {
      setOrders(response?.data?.data.orders);
    }
    setLoader(false);
  };

  useEffect(() => {
    getOrders();
  }, []);

  useEffect(() => {
    const delayInputTimeoutId = setTimeout(() => {
      getOrders();
    }, 1000);
    return () => clearTimeout(delayInputTimeoutId);
  }, [searchTerm]);

  return (
    <div className="favbg">
      <div className="innerwrapper Favourites_search">
        <div className="search_fav customscroll">
          <Deliveredsearch
            handleInputChange={handleInputChange}
            searchTerm={searchTerm}
          />
          <Deliveredtitle />
          {orders.length > 0 && <Delivereditems orders={orders} />}
          {!isLoader && orders.length <= 0 && (
            <div className="empty-search-result-wrapper">
              <div className="empty-search-result">{t('no_result_found_txt')}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Delivered;
